import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheService } from '../services/cache.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  
  constructor( private _router: Router,private cacheService: CacheService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
 
    let  isUserAuthenticated =this.cacheService.getItem('isUserAuthenticated') ? this.cacheService.getItem('isUserAuthenticated').toString() : 'false';

  if (isUserAuthenticated == 'true') {
        return true;
   } else{
    this._router.navigate(['/login']);
    return false;
   }
     
  }
   
}